import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Shopify connector can sync your Shopify store data into PostHog.`}</p>
    <p>{`To sync Shopify data:`}</p>
    <h2 {...{
      "id": "in-shopify"
    }}>{`In Shopify`}</h2>
    <ol>
      <li parentName="ol">{`Go to your Shopify store's admin panel at `}<inlineCode parentName="li">{`https://admin.shopify.com/store/your-store-id`}</inlineCode></li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Settings`}</strong>{`.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Apps and sales channels`}</strong>{`.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Develop apps`}</strong>{`.`}</li>
      <li parentName="ol"><strong parentName="li">{`IMPORTANT:`}</strong>{` Click `}<strong parentName="li">{`Build apps in Dev Dashboard`}</strong>{` (legacy apps will be deprecated January 1 2026).`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Create app`}</strong>{`.`}</li>
      <li parentName="ol">{`Give your app a name and click `}<strong parentName="li">{`Create`}</strong>{`.`}</li>
      <li parentName="ol">{`You will be redirected to a screen for releasing a new version of your app. Here, you need to:`}</li>
      <li parentName="ol">{`Set the app URL. Use the default value `}<inlineCode parentName="li">{`https://shopify.dev/apps/default-app-home`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`Choose the app scopes. We recommend that you select all read options for the simplest setup.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Release`}</strong>{` and fill in the optional release details.`}</li>
      <li parentName="ol">{`Go to `}<strong parentName="li">{`Home`}</strong>{` in the Dev Dashboard and click `}<strong parentName="li">{`Install app`}</strong>{` to install the app in your store.`}</li>
      <li parentName="ol">{`Go to `}<strong parentName="li">{`Settings`}</strong>{` in the Dev Dashboard and note your `}<inlineCode parentName="li">{`Client ID`}</inlineCode>{` and `}<inlineCode parentName="li">{`Secret`}</inlineCode>{` for later.`}</li>
    </ol>
    <p>{`For more information about creating apps in Dev Dashboard see
`}<a parentName="p" {...{
        "href": "https://shopify.dev/docs/apps/build/dev-dashboard/create-apps-using-dev-dashboard"
      }}>{`the Shopify docs`}</a>{`.`}</p>
    <h2 {...{
      "id": "in-posthog"
    }}>{`In PostHog`}</h2>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`data pipelines page`}</a>{`, and select the `}<strong parentName="li">{`Sources`}</strong>{` tab.`}</li>
      <li parentName="ol">{`Click the `}<strong parentName="li">{`+ New source`}</strong>{` button and select Shopify by clicking the `}<strong parentName="li">{`+ Create`}</strong>{` button.`}</li>
      <li parentName="ol">{`Fill in your Shopify `}<inlineCode parentName="li">{`Store ID`}</inlineCode>{` as well as the `}<inlineCode parentName="li">{`Client ID`}</inlineCode>{` and `}<inlineCode parentName="li">{`Secret`}</inlineCode>{` from above.`}</li>
      <li parentName="ol"><em parentName="li">{`Optional:`}</em>{` Add a prefix to your table names.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong>{`.`}</li>
      <li parentName="ol">{`Select the Shopify objects you want to sync, and make any sync configuration changes you need.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Import`}</strong>{`.`}</li>
    </ol>
    <p>{`After these setup steps, your Shopify data will be automatically synced to the PostHog data warehouse.
You can see details and progress in the data pipelines `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`sources tab`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      